import React from 'react';

import './Employees.css';
import {ReactComponent as ExternalIcon} from "../../images/icons/external.svg";
import API from "../../components/api";
import {SERVER_URL} from "../../config";
import Utils from "../../utils";


class EmployeesPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            vacancies: [],
            employees: []
        }

        this.renderEmployees = (employees) => {
            return <>
                {
                    employees.map(employee => {
                        return <div className='employee' onClick={() => {
                            setTimeout(() => {
                                window.open('/docs/?ref=main', '_blank');
                            }, 150)
                        }}>
                            <img src={SERVER_URL + employee.image} alt=''/>
                            <div className='info'>
                                <div className='job'>
                                    <div className='name'>
                                        {employee.name}
                                    </div>
                                    <div className='title'>
                                        {employee.description}
                                    </div>
                                    {
                                        employee.experience ? <div className='experience'>
                                            {employee.experience} лет опыта
                                        </div> : null
                                    }
                                </div>
                                {
                                    employee.url_type === 'prodoctorov' ?
                                        <a className='button' href={employee.url} target="_blank">
                                            Найти на «продокторов»
                                            <ExternalIcon/>
                                        </a> : (
                                            employee.url_type === 'other' ?
                                                <a className='button' href={employee.url} target="_blank">
                                                    Перейти
                                                    <ExternalIcon/>
                                                </a> : null
                                        )
                                }
                            </div>
                        </div>
                    })
                }
            </>
        }
    }

    componentDidMount() {
        Utils.setPageTitle('Сотрудники и вакансии')

        API.getVacanciesPage()
            .then(data => this.setState({vacancies: data}))
            .catch(() => {
            })

        API.getEmployeesPage()
            .then(data => this.setState({employees: data}))
            .catch(() => {
            })
    }

    render() {
        return <div className='employees-page'>
            <div className='page'>
                <div className='header'>
                    <div className='title'>
                        Сотрудники
                    </div>
                </div>
                <div className='employees'>
                    {this.renderEmployees(this.state.employees)}
                </div>
            </div>
            {
                this.state.vacancies.length > 0 ? <div className='jobs'>
                    <div className='header'>
                        <div className='title'>
                            Вакансии
                        </div>
                    </div>
                    <div className='list'>
                        {
                            this.state.vacancies.map(vacancy => {
                                return <div className='card'>
                                    <div className='title'>
                                        {vacancy.name}
                                    </div>
                                    <a className='button' href={vacancy.url} target='_blank'>
                                        Перейти к вакансии
                                        <ExternalIcon/>
                                    </a>
                                </div>
                            })
                        }
                    </div>
                </div> : null
            }
        </div>
    }
}


export default EmployeesPage;
